import Grade from "@/shared/models/enums/grade";
import School from "@/shared/models/entities/school";
import SchoolClass from '@/shared/models/entities/school-class';
import AccountUser from "@/shared/models/entities/account-user";
import App from "@/shared/models/entities/app";
import { dateYmd } from '@/shared/utilities/date-format';
import { isNud } from '@/shared/utilities/typing';
import { dateYmdForInputDate } from "@/shared/utilities/date-format";

/**
 * ライセンス エンティティ
 */
class License {
    license_id;
    school;
    year;
    grade;
    school_class;
    app;
    account_number;
    is_activated;
	available_from;
	available_to;
    account_users;

    constructor(properties) {
        if (isNud(properties)) {
            properties = {};
        }

        this.license_id = properties.license_id;
        this.school = new School(properties.school);
        this.year = properties.year;
        this.grade = properties.grade;
        this.school_class = new SchoolClass(properties.school_class);
        this.app = new App(properties.app);
        this.account_number = properties.account_number;
        this.is_activated = properties.is_activated;
        this.available_from = properties.available_from;
        this.available_to = properties.available_to;
        this.account_users = [];
        if ('account_users' in properties) {
            for (let account_user of properties.account_users) {
                this.account_users.push(new AccountUser(account_user));
            }
        }
    }

    get grade_display() {
        return Grade.getWhereSchoolType(this.school.school_type, this.grade);
    }

    get available_term_display() {
        if (this.available_from === null) {
            return '開始前';
        }
        let available_to = this.available_to ? dateYmd(this.available_to) : '';
        return `${dateYmd(this.available_from)} - ${available_to}`;
    }

    get available_from_for_input() {
        return dateYmdForInputDate(this.available_from);
    }

    get available_to_for_input() {
        return dateYmdForInputDate(this.available_to);
    }

    get available_from_display() {
        return dateYmd(this.available_from);
    }

    get available_to_display() {
        return dateYmd(this.available_to);
    }

    /**
     * setter
     */
    set available_from_for_input(value) {
        return this.available_from = value;
    }

    set available_to_for_input(value) {
        return this.available_to = value;
    }

}

export default License;
